module.exports = __webpack_public_path__ + "img/colombia.7e342e02.svg";